module.exports = __webpack_public_path__ + "static/img/supply-chain-finance.86a02d9b.png";